// resources
import groupEndpoints from 'api/resources/group';
import GroupService from 'services/GroupService';

// utils
import { isRoleType } from 'lib/helpers';

// constants
import { ROLES_OBJECT } from 'constants/onBoarding';

const groupService = GroupService.getInstance();
const {
  putAvatar,
  getGroupDetail,
  putGroup,
  putGroupAsShared,
  putAvatarAsTeacher,
} = groupEndpoints;

const configQuery = {
  retry: false,
  enabled: false,
};

export const classroomQuery = {
  getClassroomQuery: {
    key: 'settings-classrooms',
    resource: (id) => getGroupDetail(id),
    config: configQuery,
  },
  putClassroomQuery: {
    key: 'settings-classrooms',
    resource: ({ groupId, centerId, body }) => {
      const isTeacher = isRoleType([ROLES_OBJECT.TEACHER.value]);
      if (isTeacher) {
        return putGroup(groupId, centerId, body);
      }
      return putGroupAsShared(groupId, centerId, body);
    },
    config: configQuery,
  },
  deleteClassroomQuery: {
    resource: (centerId, groupId) =>
      groupService.deleteGroupFromCenter(centerId, groupId),
    config: configQuery,
  },
  updateClassroomQuery: {
    key: 'settings-classrooms',
    config: configQuery,
  },
};

export const putClassroomAvatarQuery = {
  key: 'classroom-avatar',
  resource: ({ groupId, centerId, body }) => {
    const isTeacher = isRoleType([ROLES_OBJECT.TEACHER.value]);
    if (isTeacher) {
      return putAvatarAsTeacher(groupId, centerId, body);
    }

    return putAvatar(groupId, centerId, body);
  },
};

export default classroomQuery;
